import { IPASEventsUrl } from "../../../../utils/AppSetting";

export const Menu = [
  {
    name: "Dashboard",
    id: "dashboard",
    to: "/",
    iconClass: "bi bi-speedometer2",
    subMenu: false,
    children: [],
  },
  {
    id: "membership",
    name: "Membership",
    iconClass: "bi bi-people",
    subMenu: true,
    children: [
      {
        id: "membershipTaskList",
        submenuName: "Membership Task List",
        to: "/MembershipTaskList",
      },
      {
        id: "upgradeMembershipTaskList",
        submenuName: "Upgrade Membership Task List",
        to: "/UpgradeMembershipTaskList",
      },
      {
        id: "reinstatementMembershipTaskList",
        submenuName: "Reinstatement Membership Task List",
        to: "/ReinstatementMembershipTaskList",
      },
      {
        id: "viewIndividualMember",
        submenuName: "View Individual Member",
        to: "/ViewIndividualMember",
      },
    ],
  },
  {
    id: "setUpAdmin",
    name: "Set Up Admin",
    iconClass: "bi bi-person-square",
    subMenu: true,
    children: [
      {
        id: "admissionCommitteeList",
        submenuName: "Admission Committee Management",
        to: "/AdmissionCommitteeList",
      },
      {
        id: "boardCommitteeList",
        submenuName: "Board of Directors Management",
        to: "/BoardCommitteeList",
      },
      // {
      //   id: "dropdownManagement",
      //   submenuName: "Dropdown Management",
      //   to: `${IPASEventsUrl}DropdownManagement`,
      //   onClick: (event) => {
      //     event.preventDefault();
      //     document.cookie = `redirectPath=/DropdownManagement;`;
      //     window.location.href = `${IPASEventsUrl}DropdownManagement`;
      //   }
      // },
      {
        id: "dropdownManagement",
        submenuName: "Dropdown Management",
        to: "/DropdownManagement",
      },
      {
        id: "emailTemplateManagement",
        submenuName: "Email Template Management",
        to: "/EmailTemplateManagement",
      }, //Membership Pricing
      {
        id: "membershipPricing",
        submenuName: "Membership Pricing",
        to: "/membershipPricing",
      },
      {
        id: "notificationBarManagement",
        submenuName: "Notification Bar Management",
        to: "/NotificationBarManagement",
      },
    ],
  },
  {
    id: "Financial",
    name: "Financial",
    iconClass: "bi bi-coin",
    subMenu: true,
    children: [
      {
        id: "businessTransactionBatchJob",
        submenuName: "Business Transaction Batch Job",
        to: "/financial/BatchJobExtraction",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=financial/BatchJobExtraction;`;
          window.location.href = `${IPASEventsUrl}financial/BatchJobExtraction`;
        }
      },
      {
        id: "chartsofAccounts",
        submenuName: "Charts of Accounts",
        to: "/financial/ChartsOfAccounts",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=financial/ChartsOfAccounts;`;
          window.location.href = `${IPASEventsUrl}financial/ChartsOfAccounts`;
        }
      },
      {
        id: "paymentReconciliation",
        submenuName: "Payment Reconciliation",
        to: "/PaymentReconciliation",
      },
      {
        id: "extractInvoices",
        submenuName: "Extract Invoices & Receipts",
        // to: "/ExtractInvoices",
        onClick: (event) => {
          event.preventDefault();
          window.location.href = `${IPASEventsUrl}financial/ExtractInvoices`;
        }
      },
      
      {
        id: "voucherCodeManagement",
        submenuName: "Voucher Code Management",
        to: "financial/VoucherCodeManagement",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=financial/VoucherCodeManagement;`;
          window.location.href = `${IPASEventsUrl}financial/VoucherCodeManagement`;
        }
      },
    ],
  },
  {
    id: "eventManagement",
    name: "Events",
    iconClass: "bi bi-bookmarks",
    subMenu: true,
    children: [
      {
        id: "createEvents",
        submenuName: "Create Events",
        to: `${IPASEventsUrl}CreateEntry`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/CreateEntry;`;
          window.location.href = `${IPASEventsUrl}CreateEntry`;
        }
      },
      {
        id: "viewEditEvent",
        submenuName: "View/Edit Event",
        to: `${IPASEventsUrl}ViewEditEntries`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/ViewEditEntries;`;
          window.location.href = `${IPASEventsUrl}ViewEditEntries`;
        }
      },
      {
        id: "marketingTrackingURL",
        submenuName: "Marketing Tracking URL",
        to: `${IPASEventsUrl}MarketingTrackingURL`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/MarketingTrackingURL;`;
          window.location.href = `${IPASEventsUrl}MarketingTrackingURL`;
        }
      },
      {
        id: "eventRegistrationApproval",
        submenuName: "Event Registration Approval",
        to: `${IPASEventsUrl}EventRegistrationApproval`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/EventRegistrationApproval;`;
          window.location.href = `${IPASEventsUrl}EventRegistrationApproval`;
        }
      },
      {
        id: "eventFeedbackQuestion",
        submenuName: "Event Feedback Question",
        to: `${IPASEventsUrl}EventFeedbackQuestion`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/EventFeedbackQuestion;`;
          window.location.href = `${IPASEventsUrl}EventFeedbackQuestion`;
        }
      },
      {
        id: "formQuestionAnswer",
        submenuName: "Event Question Answer",
        to: `${IPASEventsUrl}FormQuestionAnswer`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/FormQuestionAnswer;`;
          window.location.href = `${IPASEventsUrl}FormQuestionAnswer`;
        }
      },
      {
        id: "generateManualEventAttendenceCertificate",
        submenuName: "Manual Feedback/Cert Generation",
        to: "/GenerateManualEventAttendenceCertificate",
      },
    ],
  },
  {
    id: "bookings",
    name: "Bookings",
    iconClass: "bi bi-calendar-event",
    subMenu: true,
    children: [
      {
        id: "viewNewBookings",
        submenuName: "View New Bookings",
        to: "/booking/ViewNewBookings",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/booking/ViewNewBookings;`;
          window.location.href = `${IPASEventsUrl}booking/ViewNewBookings`;
        }
      },
      {
        id: "viewBookingCancellations",
        submenuName: "View Booking Cancellations",
        to: "/BookingCancellation",
      },
      // {
      //   id: "viewBookingCancellation",
      //   submenuName: "View Booking Cancellations",
      //   to: "/viewBookingCancellation",
      //   onClick: (event) => {
      //     event.preventDefault();
      //     document.cookie = `redirectPath=/viewBookingCancellation;`;
      //     window.location.href = `${IPASEventsUrl}viewBookingCancellation`;
      //   }
      // }
    ],
  },
  {
    id: "cms",
    name: "CMS",
    iconClass: "bi bi-body-text",
    subMenu: true,
    children: [
      {
        id: "gallery",
        submenuName: "Gallery",
        to: "/eventsGalleryList",
      },
      {
        id: "manageEventGallery",
        submenuName: "Manage Event Gallery",
        to: "/manageEventGallery",
      },
      {
        id: "viewResources",
        submenuName: "Resources",
        to: `${IPASEventsUrl}ViewResource`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/ViewResource;`;
          window.location.href = `${IPASEventsUrl}ViewResource`;
        }
      },
      {
        id: "pageManagement",
        submenuName: "Page Management",
        to: `${IPASEventsUrl}ViewPages`,
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=/ViewPages;`;
          window.location.href = `${IPASEventsUrl}ViewPages`;
        }
      },
      {
        id: "workgroupMapping",
        submenuName: "Leadership Management",
        to: "/WorkgroupMapping",
      },
    ],
  },
  {
    id: "reports",
    name: "Reports",
    iconClass: "bi bi-file-earmark-spreadsheet",
    subMenu: true,
    children: [
      {
        id: "transactionReport",
        submenuName: "Transaction Report",
        to: "reports/TransactionReport",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=reports/TransactionReport;`;
          window.location.href = `${IPASEventsUrl}reports/TransactionReport`;
        }
      },
      {
        id: "membershipReport",
        submenuName: "Membership Report",
        to: "reports/MembershipReport",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=reports/MembershipReport;`;
          window.location.href = `${IPASEventsUrl}reports/MembershipReport`;
        }
      },
      {
        id: "insolReport",
        submenuName: "INSOL Report",
        to: "reports/INSOLReport",
        onClick: (event) => {
          event.preventDefault();
          document.cookie = `redirectPath=reports/INSOLReport;`;
          window.location.href = `${IPASEventsUrl}reports/INSOLReport`;
        }
      },
    ],
  },
];